<template>
  <div>
    <PageHeader :title="nameTitle" :items="headerItems" />
    <StatusBar @updateStatus="updateStatus($event)" :transitions="transitions" class="team-task-detail-status-bar" />
    <div class="mt-4">
      <ReadOnly :componentData="readonlyData" />
    </div>
  </div>
</template>

<script>
import PageHeader from '@/components/layoutComponents/page-header'
import StatusBar from '../teamtask/StatusBar.vue'
import ReadOnly from '../common/form/type/ReadOnly.vue'
import walletDataProvider from '../../services/wallet'

export default {
  name: 'crypto-transaction',
  components: {
    PageHeader,
    StatusBar,
    ReadOnly,
  },
  data() {
    return {
      transitions: [{ id: Number(this.$route.params.id), name: 'ناموفق', color: 'rgb(244, 106, 106)', actionId: null }],
      readonlyData: {},
    }
  },

  methods: {
    updateStatus(payload) {
      walletDataProvider
        .rollBackTransaction({
          transactionId: payload.id,
        })
        .then((res) => {
          this.getData({ transactionId: this.transactionId })
        })
        .catch((err) => {})
    },
    getData(payload) {
      walletDataProvider
        .getUserCryptoTransactionDetail(payload)
        .then((res) => {
          this.readonlyData = res.data.data.detail
          this.readonlyData.id = this.transactionId
        })
        .catch((err) => console.log(err))
    },
  },
  computed: {
    nameTitle() {
      return 'جزییات تراکنش های ارزی'
    },
    headerItems() {
      return [
        {
          text: 'داشبورد',
          href: '/',
        },
        {
          text: this.nameTitle,
          active: true,
        },
      ]
    },
    transactionId() {
      return this.$route.params.id
    },
  },
  beforeMount() {
    this.getData({ transactionId: this.transactionId })
  },
}
</script>

<style scoped lang="scss">
.team-task-detail-header {
  width: 100%;
  position: sticky;
  top: 60px;
  z-index: 4;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #f8f8fb;
}
::v-deep .collapse .card-body {
  background-color: #ffffff;
}
</style>
